module.exports = __webpack_public_path__ + "55620c3c0e076483584c0d5cc2511ae1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-23.png
// module id = 2009
// module chunks = 0